export default __webpack_public_path__ + "static/media/docker.7fadbc97.png";